"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validators = exports.validateFieldStrLen = exports.validate = exports.showSeniorCitizenField = exports.replaceAge = exports.renderSingleSelect = exports.renderSelect = exports.renderField = exports.renderDropdown = exports.renderDate = exports.removeExtraWhiteSpaces = exports.parseDate = exports.default = exports.createGtmObject = exports.createErrorGtmObject = exports.FieldWrapper = exports.FieldGroup = exports.Container = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _formik = require("formik");
var _dateFns = require("date-fns");
var _differenceInCalendarYears = _interopRequireDefault(require("date-fns/differenceInCalendarYears"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _TextField = _interopRequireDefault(require("../TextField"));
var _Select = _interopRequireDefault(require("../Select"));
var _SingleClickSelection = _interopRequireDefault(require("../SingleClickSelection"));
var _DateInput = _interopRequireDefault(require("../DateInput"));
var _Popover = _interopRequireDefault(require("../Popover"));
var _IDCard = _interopRequireDefault(require("../IDCard"));
var _CardInfo = _interopRequireDefault(require("../CardInfo"));
var _GtmContext = require("@airasia/phoenix-common/common/GtmContext");
var _constant = require("../constant");
var _Dropdown = _interopRequireDefault(require("../Dropdown"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _GuestPersonalInfo = _interopRequireDefault(require("./GuestPersonalInfo.proptypes"));
var _constant2 = require("./constant");
var _excluded = ["form", "handleField", "errorCallback", "touched", "triggerOnChange"],
  _excluded2 = ["form", "handleField", "isMobileV2", "errorCallback", "touched"],
  _excluded3 = ["form", "handleField", "isMobileV2", "errorCallback", "touched", "items", "theme", "value"],
  _excluded4 = ["form", "handleField", "customDisplayField", "errorCallback", "touched", "sortNationlityByCultureCode"],
  _excluded5 = ["form", "handleField", "isMobile", "errorCallback", "touched", "triggerOnChange", "displayYPTA", "paxType"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "GuestPersonalInfo__StyledContainer",
  componentId: "sc-uzmc8s-0"
})([""]);
var Container = _styledComponents.default.div.withConfig({
  displayName: "GuestPersonalInfo__Container",
  componentId: "sc-uzmc8s-1"
})(["display:flex;flex-wrap:wrap;"]);
exports.Container = Container;
var StyledYptaDisclaimerContainer = _styledComponents.default.div.withConfig({
  displayName: "GuestPersonalInfo__StyledYptaDisclaimerContainer",
  componentId: "sc-uzmc8s-2"
})(["padding:", ";"], function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.space.XXSmall);
});
var replaceAge = function replaceAge(str, ageRange) {
  return str.replace('{age}', ageRange.min).replace('{max}', ageRange.max);
};
exports.replaceAge = replaceAge;
var FieldWrapper = _styledComponents.default.div.withConfig({
  displayName: "GuestPersonalInfo__FieldWrapper",
  componentId: "sc-uzmc8s-3"
})(["width:", "%;padding:", ";box-sizing:border-box;"], function (_ref2) {
  var isMobile = _ref2.isMobile,
    isFullWidth = _ref2.isFullWidth,
    width = _ref2.width;
  return isMobile || isFullWidth ? '100' : width || '50';
}, function (_ref3) {
  var theme = _ref3.theme,
    title = _ref3.title;
  return title ? "".concat(theme.space.none, " ").concat(theme.space.tiny, " ").concat(theme.space.none, " ").concat(theme.space.tiny) : "".concat(theme.space.tiny, " ").concat(theme.space.tiny);
});
exports.FieldWrapper = FieldWrapper;
var FieldGroup = _styledComponents.default.div.withConfig({
  displayName: "GuestPersonalInfo__FieldGroup",
  componentId: "sc-uzmc8s-4"
})(["width:", "%;position:relation;display:flex;"], function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? '100' : '50';
});
/* istanbul ignore next */
exports.FieldGroup = FieldGroup;
var parseDate = function parseDate(date) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constant2.DATE_FORMAT;
  return (0, _dateFns.parse)(date, dateFormat, new Date());
};
exports.parseDate = parseDate;
var removeExtraWhiteSpaces = function removeExtraWhiteSpaces(value) {
  return value === null || value === void 0 ? void 0 : value.replace(/\s{2,}/g, ' ').trim();
};
exports.removeExtraWhiteSpaces = removeExtraWhiteSpaces;
var validateFieldStrLen = function validateFieldStrLen(fieldName, limit, translation) {
  return translation["".concat(fieldName, "MaxError")].replace('{number}', limit); // field based max length error
};
exports.validateFieldStrLen = validateFieldStrLen;
var getErrorObj = function getErrorObj(code, message) {
  return {
    errorCode: code,
    errorMessage: message || _constant2.TRANSLATION[code] || ''
  };
};
var showYptaDisclaimer = function showYptaDisclaimer(value, isMobile, paxType, flightDate, yptaAgeRange) {
  var exactYptaAgeValidation = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  if (paxType.toLowerCase() !== _constant2.PAX_TYPE.adult.toLowerCase()) {
    return false;
  }
  if (value) {
    var formattedValue = value;
    if (isMobile) {
      formattedValue = _constant2.DATE_FORMAT_REGEX.test(value) ? value : (0, _dateFns.format)(new Date(value), _constant2.DATE_FORMAT);
    }
    if (_constant2.DATE_FORMAT_REGEX.test(formattedValue)) {
      // split by / to get the actual m,d,y value
      var dateArr = formattedValue && formattedValue.split('/').map(function (val) {
        return parseInt(val, 10);
      });
      var fligtDateArr = flightDate && flightDate.split('/').map(function (val) {
        return parseInt(val, 10);
      });
      var dateVal = dateArr.length && new Date(dateArr[2], dateArr[1] - 1, dateArr[0]);
      var ageDurationFlightDate = (0, _dateFns.intervalToDuration)({
        start: new Date(dateArr[2], dateArr[1] - 1, dateArr[0], 0, 0, 0),
        // birthdate
        end: new Date(fligtDateArr[2], fligtDateArr[1] - 1, fligtDateArr[0], 0, 0, 0) // flight date
      });

      if (dateVal && !(0, _dateFns.isValid)(new Date(dateArr[2], dateArr[1] - 1, dateArr[0]))) return false;
      var months = ageDurationFlightDate.months,
        days = ageDurationFlightDate.days,
        years = ageDurationFlightDate.years;
      var AGE_RANGE = _objectSpread(_objectSpread({}, _constant2.YPTA_AGE_RANGE), yptaAgeRange);
      if (exactYptaAgeValidation) {
        var isYpta = false;
        if (years >= AGE_RANGE.min && years <= AGE_RANGE.max) {
          isYpta = true;
        }

        // If the age is max range and days and months is greater than 1
        if (years >= AGE_RANGE.min && years === AGE_RANGE.max && (months > 0 || days > 0)) {
          isYpta = false;
        }
        return isYpta;
      }
      return years >= AGE_RANGE.min && years <= AGE_RANGE.max;
    }
  }
  return false;
};
var toDisplayYPTA = function toDisplayYPTA(yptaDisclaimerContent, value, isMobile, paxType, flightDate, yptaAgeRange) {
  var exactYptaAgeValidation = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  return yptaDisclaimerContent && showYptaDisclaimer(value, isMobile, paxType, flightDate, yptaAgeRange, exactYptaAgeValidation);
};
var _validate = {
  /* istanbul ignore next */
  alphabet: function alphabet(value, field, translation) {
    /* istanbul ignore next */
    return value && !_constant2.ALPHABET_REGEX.test(value) ? getErrorObj('alphabetError', translation.alphabetError) : '';
  },
  /* istanbul ignore next */
  alphanumeric: function alphanumeric(value, field, translation) {
    /* istanbul ignore next */
    return value && !_constant2.ALPHANUMERIC_REGEX.test(value) ? getErrorObj('alphanumericError', translation.alphanumericError) : '';
  },
  alphanumericspace: function alphanumericspace(value, field, translation) {
    /* istanbul ignore next */
    return value && !_constant2.ALPHANUMERIC_NO_SPACE_REGEX.test(value) ? getErrorObj('alphanumericError', translation.alphanumericError) : '';
  },
  /* istanbul ignore next */
  required: function required(value, field, translation) {
    /* istanbul ignore next */
    return value ? '' : getErrorObj('requiredError', translation.requiredError);
  },
  /* istanbul ignore next */
  date: function date(value, field, translation, isMobile, paxType, flightDate) {
    var birthDate = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var customAgeRange = arguments.length > 7 ? arguments[7] : undefined;
    var passport = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
    var isRequired = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : true;
    var hasInfant = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : false;
    var yptaDisclaimerContent = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : null;
    var yptaAgeRange = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : null;
    var newYpta = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : false;
    var exactYptaAgeValidation = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : false;
    // DATE
    /* istanbul ignore next */
    var error = isRequired ? _validate.required(value, field, translation) : '';
    if (value) {
      var formattedValue = value;
      if (isMobile) {
        formattedValue = _constant2.DATE_FORMAT_REGEX.test(value) ? value : (0, _dateFns.format)(new Date(value), _constant2.DATE_FORMAT);
      }
      if (_constant2.DATE_FORMAT_REGEX.test(formattedValue)) {
        // split by / to get the actual m,d,y value
        var dateArr = formattedValue && formattedValue.split('/').map(function (val) {
          return parseInt(val, 10);
        });
        var fligtDateArr = flightDate && flightDate.split('/').map(function (val) {
          return parseInt(val, 10);
        });
        var dateVal = dateArr.length && new Date(dateArr[2], dateArr[1] - 1, dateArr[0]);
        var flightDateVal = fligtDateArr.length ? new Date(fligtDateArr[2], fligtDateArr[1] - 1, fligtDateArr[0]) : (0, _dateFns.format)(new Date(flightDate), _constant2.DATE_FORMAT);

        // /* istanbul ignore next */
        // const yearsDiff = differenceInCalendarYears(new Date(), dateVal);
        // const daysDiff = differenceInDays(new Date(), dateVal);
        // console.log(yearsDiff, daysDiff);
        // /* istanbul ignore next */
        // const yearsFromFlightDate = differenceInCalendarYears(flightDateVal, dateVal);

        var ageDurationFlightDate = (0, _dateFns.intervalToDuration)({
          start: new Date(dateArr[2], dateArr[1] - 1, dateArr[0], 0, 0, 0),
          // birthdate
          end: new Date(fligtDateArr[2], fligtDateArr[1] - 1, fligtDateArr[0], 0, 0, 0) // flight date
        });

        /* istanbul ignore next */
        if (dateVal && !(0, _dateFns.isValid)(new Date(dateArr[2], dateArr[1] - 1, dateArr[0]))) error = getErrorObj('dateError', translation.dateError);
        /* istanbul ignore next */
        if (birthDate) {
          var AGE_RANGE = _objectSpread(_objectSpread({}, _constant2.PAX_MAX_AGE), customAgeRange);
          var minDate = new Date(_constant2.MIN_DATE_TO_VALIDATE);
          var displayYPTA = newYpta && toDisplayYPTA(yptaDisclaimerContent, value, isMobile, paxType, flightDate, yptaAgeRange, exactYptaAgeValidation);

          // validate the minimum date
          if (dateVal < minDate) error = getErrorObj('dateError', translation.dateError);else {
            /* istanbul ignore next */
            switch (paxType.toLowerCase()) {
              case _constant2.PAX_TYPE.adult.toLowerCase():
                /* istanbul ignore next */
                // if (hasInfant && (yearsFromFlightDate < AGE_RANGE.adult.min || yearsDiff < AGE_RANGE.adult.min)) {
                if (hasInfant && ageDurationFlightDate.years < AGE_RANGE.adult.min) {
                  error = getErrorObj('hasInfantError', translation.hasInfantError);
                } else if (ageDurationFlightDate.years < AGE_RANGE.adult.min || dateVal.getTime() > new Date().getTime()) {
                  error = getErrorObj('hasInfantError', replaceAge(translation.adultAgeError, AGE_RANGE.adult));
                } else if (displayYPTA) {
                  error = getErrorObj('yptaValidationMessage', translation.yptaValidationMessage);
                }
                break;
              case _constant2.PAX_TYPE.child.toLowerCase():
                /* istanbul ignore next */
                if (ageDurationFlightDate.years >= AGE_RANGE.adult.min || ageDurationFlightDate.years < AGE_RANGE.child.min || dateVal.getTime() > new Date().getTime()) {
                  /* istanbul ignore next */
                  error = getErrorObj('childAgeError', replaceAge(translation.childAgeError, AGE_RANGE.child));
                }
                /* istanbul ignore next */
                break;
              case _constant2.PAX_TYPE.infant.toLowerCase():
                /* istanbul ignore next */
                if (ageDurationFlightDate.years >= AGE_RANGE.child.min || dateVal.getTime() > new Date().getTime()) {
                  error = getErrorObj('infantAgeError', replaceAge(translation.infantAgeError, AGE_RANGE.infant));
                }
                /* istanbul ignore next */
                break;
              default:
                /* istanbul ignore next */
                error = '';
                /* istanbul ignore next */
                break;
            }
          }
        }
        /* istanbul ignore next */
        if (dateVal && passport) {
          var now = (0, _dateFns.getTime)(new Date());
          var expiry = (0, _dateFns.getTime)(dateVal);
          var fDate = (0, _dateFns.getTime)(flightDateVal);
          var expiryPlusSixMonths = new Date(flightDateVal.setMonth(flightDateVal.getMonth() + 6)).getTime();
          if (expiry < now || flightDateVal && expiry < fDate) {
            error = getErrorObj('expiredError', translation.expiredError);
          } else if (expiry <= expiryPlusSixMonths) {
            error = getErrorObj('dateExpiredAfter', translation.dateExpiredAfter);
          }
        }
      } else {
        error = getErrorObj('dateError', translation.dateError);
      }
    }
    /* istanbul ignore next */
    return error;
  },
  maxLen: function maxLen(value, field, translation) {
    var strLen = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
    var dependentLength = arguments.length > 4 ? arguments[4] : undefined;
    var fieldName = arguments.length > 5 ? arguments[5] : undefined;
    if ((0, _typeof2.default)(strLen) === 'object') {
      // allowedNameLength cheker
      var totalLength = value.length + dependentLength;
      if (totalLength > strLen.totalNameLength && value && dependentLength) {
        if (fieldName === _constant2.FIELDS.familyName.name) {
          return validateFieldStrLen(_constant2.TOTAL_NAME, strLen.totalNameLength, translation);
        }
      }
      if (value && value.length > strLen["".concat(fieldName, "Length")]) {
        return validateFieldStrLen(fieldName, strLen["".concat(fieldName, "Length")], translation);
      }
    }
    // default maxCharLengthAllowed checker
    var lengthLimit = strLen.totalNameLength || strLen;
    return value && value.length > lengthLimit ? getErrorObj('maxLengthError', translation.maxLengthError.replace('{max}', lengthLimit)) : '';
  }
};
exports.validate = _validate;
var showSeniorCitizenField = function showSeniorCitizenField(dateOfBirth, isMobile, paxType, flightDate, seniorCitizenMinAge, checkSeniorCitizenField, newVersion) {
  if (paxType.toLowerCase() !== _constant2.PAX_TYPE.adult.toLowerCase()) {
    if (!newVersion) checkSeniorCitizenField(false);
    return false;
  }
  if (dateOfBirth) {
    // const formattedValue = isMobile ? format(new Date(dateOfBirth), DATE_FORMAT) : dateOfBirth;
    var formattedValue = dateOfBirth;
    if (isMobile) {
      formattedValue = _constant2.DATE_FORMAT_REGEX.test(dateOfBirth) ? dateOfBirth : (0, _dateFns.format)(new Date(dateOfBirth), _constant2.DATE_FORMAT);
    }
    if (_constant2.DATE_FORMAT_REGEX.test(formattedValue)) {
      // split by / to get the actual m,d,y value
      var dateArr = formattedValue && formattedValue.split('/').map(function (val) {
        return parseInt(val, 10);
      });
      var fligtDateArr = flightDate && flightDate.split('/').map(function (val) {
        return parseInt(val, 10);
      });
      var dateVal = dateArr.length && new Date(dateArr[2], dateArr[1] - 1, dateArr[0]);
      var flightDateVal = fligtDateArr !== null && fligtDateArr !== void 0 && fligtDateArr.length ? new Date(fligtDateArr[2], fligtDateArr[1] - 1, fligtDateArr[0]) : (0, _dateFns.format)(new Date(flightDate), _constant2.DATE_FORMAT);
      var yearsFromFlightDate = (0, _differenceInCalendarYears.default)(flightDateVal, dateVal);
      if (dateVal && !(0, _dateFns.isValid)(new Date(dateArr[2], dateArr[1] - 1, dateArr[0]))) {
        if (!newVersion) checkSeniorCitizenField(false);
        return false;
      }
      var AGE_RANGE = _objectSpread(_objectSpread({}, _constant2.SENIOR_CITIZEN_MIN_AGE), seniorCitizenMinAge);
      if (!newVersion) checkSeniorCitizenField(yearsFromFlightDate >= AGE_RANGE.min);
      return yearsFromFlightDate >= AGE_RANGE.min;
    }
  }
  if (!newVersion) checkSeniorCitizenField(false);
  return false;
};
exports.showSeniorCitizenField = showSeniorCitizenField;
var validators = function validators(value, field, translation, validations) {
  for (var _len = arguments.length, customData = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
    customData[_key - 4] = arguments[_key];
  }
  var error;

  /* istanbul ignore next */
  validations.forEach(function (validator) {
    var validationError = validator.apply(void 0, [value, field, translation].concat(customData));
    if (validationError) error = validationError;
  });

  /* istanbul ignore next */
  return error;
};
exports.validators = validators;
var createGtmObject = function createGtmObject(fieldName, gtmParams, gtmLabel, fireGtm) {
  var label = gtmParams.eventLabelView ? gtmParams.eventLabelView.replace('givenname', fieldName) : null;
  var eventLabel = gtmLabel && label ? label.replace('bookersinfo', gtmLabel) : label;
  var obj = {
    event: gtmParams.event,
    'eventDetails.category': gtmParams.eventCategory,
    'eventDetails.action': gtmParams.eventActionClick,
    'eventDetails.label': eventLabel
  };
  // eslint-disable-next-line no-unused-expressions
  obj ? fireGtm(obj, 'true') : null;
};
exports.createGtmObject = createGtmObject;
var createErrorGtmObject = function createErrorGtmObject(field, gtmLabel, fireGtm) {
  var gtmAppName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Flights';
  var lineOfBusiness = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'OTA';
  var obj = {
    event: 'trackEventNoEcommerce',
    'eventDetails.category': "".concat(gtmAppName, "|GuestDetailsError"),
    'eventDetails.action': 'fieldLeftEmpty',
    'eventDetails.label': "".concat(field.length > 1 ? 'Multiple Fields' : 'One Field', "|").concat(gtmLabel, "|").concat(field.length > 1 ? 'bookersinfo' : field[0]),
    lineofbusiness: lineOfBusiness
  };
  // eslint-disable-next-line no-unused-expressions
  obj && fireGtm ? fireGtm(obj, 'true') : null;
};
exports.createErrorGtmObject = createErrorGtmObject;
var renderField = function renderField(fieldProps) {
  var _errors$field;
  var form = fieldProps.form,
    handleField = fieldProps.handleField,
    errorCallback = fieldProps.errorCallback,
    touched = fieldProps.touched,
    triggerOnChange = fieldProps.triggerOnChange,
    rest = (0, _objectWithoutProperties2.default)(fieldProps, _excluded);
  var errors = form.errors;
  var field = rest.field.name;
  return /*#__PURE__*/_react.default.createElement(_TextField.default, (0, _extends2.default)({}, rest, {
    type: "text",
    onChange: function onChange(e) {
      var _handleField;
      // eslint-disable-next-line no-unused-expressions
      triggerOnChange ? handleField((_handleField = {}, (0, _defineProperty2.default)(_handleField, field, e.target.value), (0, _defineProperty2.default)(_handleField, "trigger", false), _handleField)) : null;
      /* istanbul ignore next */
      form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, e.target.value)));
      /* istanbul ignore next */
      form.setFieldTouched(field, true, true);
      // console.log(errors ? field : 'none')
    },

    onBlur: function onBlur(e) {
      var _handleField2;
      /* istanbul ignore next */
      handleField((_handleField2 = {}, (0, _defineProperty2.default)(_handleField2, field, e.target.value), (0, _defineProperty2.default)(_handleField2, "trigger", true), _handleField2));
      /* istanbul ignore next */
      form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, e.target.value !== '' || e.target.value !== null ? removeExtraWhiteSpaces(e.target.value) : e.target.value)));
      /* istanbul ignore next */
      form.setFieldTouched(field, true, true);
      // eslint-disable-next-line no-unused-expressions
      errors && errors[field] && errorCallback ? errorCallback(field, errors[field], true) : errorCallback(field, undefined, false);
    },
    onClick: function onClick() {
      // form.setFieldTouched(field, true, false);
      // eslint-disable-next-line no-unused-expressions
      fieldProps.gtmAction && typeof fieldProps.gtmParams !== 'undefined' ? fieldProps.createGtmObject(field, fieldProps.gtmParams, fieldProps.gtmLabel, fieldProps.gtmAction) : undefined;
    },
    validateMessage: ((_errors$field = errors[field]) === null || _errors$field === void 0 ? void 0 : _errors$field.errorMessage) || '',
    customProperties: fieldProps.customProperties
  }, touched && fieldProps.isRequired && {
    validateStatus: errors[field] ? 'error' : 'success'
  }));
};
exports.renderField = renderField;
var renderSelect = function renderSelect(fieldProps) {
  var _errors$field2;
  var form = fieldProps.form,
    handleField = fieldProps.handleField,
    isMobileV2 = fieldProps.isMobileV2,
    errorCallback = fieldProps.errorCallback,
    touched = fieldProps.touched,
    rest = (0, _objectWithoutProperties2.default)(fieldProps, _excluded2);
  var errors = form.errors;
  var field = rest.field.name;
  return /*#__PURE__*/_react.default.createElement(_Select.default, (0, _extends2.default)({}, rest, {
    onChange: function onChange(val) {
      /* istanbul ignore next */
      form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, val)));
      setTimeout(function () {
        /* istanbul ignore next */
        form.setFieldTouched(field, true, true);
        /* istanbul ignore next */
        handleField((0, _defineProperty2.default)({}, field, val));
      });
    },
    onBlur: function onBlur(val) {
      /* istanbul ignore next */
      handleField((0, _defineProperty2.default)({}, field, val));
      /* istanbul ignore next */
      form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, val)));
      /* istanbul ignore next */
      form.setFieldTouched(field, true, true);
      // eslint-disable-next-line no-unused-expressions
      errors && errors[field] && errorCallback ? errorCallback(field, errors[field], true) : errorCallback(field, undefined, false);
    },
    validateMessage: ((_errors$field2 = errors[field]) === null || _errors$field2 === void 0 ? void 0 : _errors$field2.errorMessage) || ''
  }, touched && {
    validateStatus: errors[field] ? 'error' : 'success'
  }, {
    isMobileV2: isMobileV2,
    withLabelOpacity: fieldProps.withLabelOpacity,
    onClick: function onClick() {
      // eslint-disable-next-line no-unused-expressions
      fieldProps.onClick;
      // eslint-disable-next-line no-unused-expressions
      fieldProps.gtmAction && typeof fieldProps.gtmParams !== 'undefined' ? fieldProps.createGtmObject(field, fieldProps.gtmParams, fieldProps.gtmLabel, fieldProps.gtmAction) : undefined;
    },
    disabled: fieldProps.disableDropdown ? fieldProps.disableDropdown : false,
    customProperties: fieldProps.customProperties
  }));
};
exports.renderSelect = renderSelect;
var renderSingleSelect = function renderSingleSelect(fieldProps) {
  var form = fieldProps.form,
    handleField = fieldProps.handleField,
    isMobileV2 = fieldProps.isMobileV2,
    errorCallback = fieldProps.errorCallback,
    touched = fieldProps.touched,
    items = fieldProps.items,
    theme = fieldProps.theme,
    value = fieldProps.value,
    rest = (0, _objectWithoutProperties2.default)(fieldProps, _excluded3);
  var errors = form.errors;
  var field = rest.field.name;
  // const default = items && fieldProps.value && items.filter((item) => item.value === fieldProps.value)[0];
  return /*#__PURE__*/_react.default.createElement(_SingleClickSelection.default, {
    accessible: false,
    color: fieldProps.color,
    selectButtonBackgroundColor: fieldProps.selectButtonBackgroundColor,
    selectedButtonBorderColor: fieldProps.selectedButtonBorderColor,
    customButtonWidth: fieldProps.customButtonWidth,
    data: items,
    theme: theme,
    vertical: false,
    value: fieldProps.value,
    onClick: function onClick(val) {
      // eslint-disable-next-line no-unused-expressions
      fieldProps.gtmAction && typeof fieldProps.gtmParams !== 'undefined' ? fieldProps.createGtmObject(field, fieldProps.gtmParams, fieldProps.gtmLabel, fieldProps.gtmAction) : undefined;
      form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, val)));
      form.setFieldTouched(field, true, false);
      handleField((0, _defineProperty2.default)({}, field, val));
    },
    customProperties: fieldProps.customProperties
  });
};
exports.renderSingleSelect = renderSingleSelect;
var filterList = function filterList(inputValue, callback, items) {
  var result = inputValue && inputValue !== '' && inputValue !== null ? items.filter(function (option) {
    return option.mainDisplayName.toLowerCase().includes(inputValue.toLowerCase()) || option.iconDisplayName && option.iconDisplayName.toLowerCase().includes(inputValue.toLowerCase());
  }) : items;
  callback(result);
};
var renderDropdown = function renderDropdown(fieldProps) {
  var _errors$field3;
  var form = fieldProps.form,
    handleField = fieldProps.handleField,
    customDisplayField = fieldProps.customDisplayField,
    errorCallback = fieldProps.errorCallback,
    touched = fieldProps.touched,
    sortNationlityByCultureCode = fieldProps.sortNationlityByCultureCode,
    rest = (0, _objectWithoutProperties2.default)(fieldProps, _excluded4);
  var errors = form.errors;
  var field = rest.field.name;
  // eslint-disable-next-line max-len
  var customValueToDisplay = fieldProps.items && fieldProps.value && customDisplayField && fieldProps.items.filter(function (item) {
    return item.value === fieldProps.value;
  })[0];

  // Check if the sortNationlityByCultureCode is available, use it as sort for the items
  if (sortNationlityByCultureCode) {
    var langCode = sortNationlityByCultureCode.split('-')[0];
    if (langCode) {
      fieldProps.items.sort(function (a, b) {
        return a.label.localeCompare(b.label, langCode === null || langCode === void 0 ? void 0 : langCode.toLowerCase());
      });
    }
  }
  var onSelectHandler = function onSelectHandler(obj) {
    if (obj) {
      // with selected Value
      /* istanbul ignore next */
      form.setFieldValue(field, obj.value, true);
      setTimeout(function () {
        /* istanbul ignore next */
        form.setFieldTouched(field, true, false);
        /* istanbul ignore next */
        handleField((0, _defineProperty2.default)({}, field, obj.value));
      });
    } else {
      // No selected Value null
      /* istanbul ignore next */
      form.setFieldValue(field, '', true);
      /* istanbul ignore next */
      form.setFieldTouched(field, true, false);
      setTimeout(function () {
        /* istanbul ignore next */
        handleField((0, _defineProperty2.default)({}, field, ''));
      });
    }
    form.setFieldTouched(field, true, false);
  };
  return /*#__PURE__*/_react.default.createElement(_Dropdown.default, (0, _extends2.default)({}, rest, {
    theme: fieldProps.theme,
    viewPort: fieldProps.isMobile ? 'mobile' : 'desktop',
    width: fieldProps.isMobile ? '' : '300px',
    onChange: filterList,
    isNewVersion: true,
    onSelect: function onSelect(obj) {
      onSelectHandler(obj);
    },
    locale: _constant2.TRANSLATION,
    supportOneCharacterSearch: true,
    alwaysShowLabel: false,
    onFocus: function onFocus() {
      // eslint-disable-next-line no-unused-expressions
      fieldProps.gtmAction && typeof fieldProps.gtmParams !== 'undefined' ? fieldProps.createGtmObject(field, fieldProps.gtmParams, fieldProps.gtmLabel, fieldProps.gtmAction) : undefined;
    },
    onBlur: function onBlur(obj) {
      /* istanbul ignore next */
      form.setFieldValue(field, obj.value, true);
      /* istanbul ignore next */
      form.setFieldTouched(field, true, false);
      /* istanbul ignore next */
      handleField((0, _defineProperty2.default)({}, field, obj.value));
      // eslint-disable-next-line no-unused-expressions
      errors && errors[field] && errorCallback ? errorCallback(field, errors[field], true) : errorCallback(field, undefined, false);
    },
    defaultValue: customValueToDisplay && customValueToDisplay[customDisplayField] || fieldProps.value,
    customDisplayValue: customValueToDisplay && customValueToDisplay[customDisplayField] || '',
    validateMessage: ((_errors$field3 = errors[field]) === null || _errors$field3 === void 0 ? void 0 : _errors$field3.errorMessage) || ''
  }, touched && {
    validateStatus: errors[field] ? 'error' : 'success'
  }, {
    customDisplayField: customDisplayField,
    withBoxShadow: fieldProps.withBoxShadow,
    isCountryCode: fieldProps.isCountryCode,
    customProperties: fieldProps.customProperties,
    enableOnChangeOnceEmpty: true
  }));
};
exports.renderDropdown = renderDropdown;
var renderDate = function renderDate(fieldProps) {
  var _errors$field4;
  var form = fieldProps.form,
    handleField = fieldProps.handleField,
    isMobile = fieldProps.isMobile,
    errorCallback = fieldProps.errorCallback,
    touched = fieldProps.touched,
    triggerOnChange = fieldProps.triggerOnChange,
    displayYPTA = fieldProps.displayYPTA,
    paxType = fieldProps.paxType,
    rest = (0, _objectWithoutProperties2.default)(fieldProps, _excluded5);
  var errors = form.errors,
    status = form.status,
    setStatus = form.setStatus;
  var field = rest.field.name;
  var validateStatus = _constant2.VALIDATION_STATUS.SUCCESS;
  if (displayYPTA && errors[field]) {
    validateStatus = _constant2.VALIDATION_STATUS.WARNING;
    if (!status) {
      setStatus(_constant2.VALIDATION_STATUS.WARNING);
    }
  } else if (errors[field]) {
    validateStatus = _constant2.VALIDATION_STATUS.ERROR;
  }
  return /*#__PURE__*/_react.default.createElement(_DateInput.default, (0, _extends2.default)({}, rest, {
    isMobile: isMobile,
    variableWidth: true,
    dateFormat: _constant2.DATE_FORMAT,
    onChange: function onChange(e) {
      var _handleField9;
      // eslint-disable-next-line no-unused-expressions
      triggerOnChange ? handleField((_handleField9 = {}, (0, _defineProperty2.default)(_handleField9, field, e.target.value), (0, _defineProperty2.default)(_handleField9, "trigger", false), _handleField9)) : null;
      /* istanbul ignore next */
      form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, e.target.value)));
      /* istanbul ignore next */
      form.setFieldTouched(field, true, isMobile);
      form.setStatus(validateStatus);
    },
    onBlur: function onBlur(e) {
      var _handleField10;
      /* istanbul ignore next */
      handleField((_handleField10 = {}, (0, _defineProperty2.default)(_handleField10, field, e.target.value), (0, _defineProperty2.default)(_handleField10, "trigger", true), _handleField10));
      /* istanbul ignore next */
      form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, e.target.value)));
      /* istanbul ignore next */
      form.setFieldTouched(field, true, true);
      form.setStatus(validateStatus);
      // eslint-disable-next-line no-unused-expressions
      errors[field] && errorCallback(field, errors[field], true);
      /*   errors[field] && errorCallback
        ? errorCallback(field, errors[field], true)
        : errorCallback(field, undefined, false); */
    },

    onFocus: function onFocus() {
      // eslint-disable-next-line no-unused-expressions
      fieldProps.gtmAction && typeof fieldProps.gtmParams !== 'undefined' ? fieldProps.createGtmObject(field, fieldProps.gtmParams, fieldProps.gtmLabel, fieldProps.gtmAction) : undefined;
    },
    validateMessage: ((_errors$field4 = errors[field]) === null || _errors$field4 === void 0 ? void 0 : _errors$field4.errorMessage) || '',
    customProperties: fieldProps.customProperties
  }, touched && fieldProps.isRequired && {
    validateStatus: validateStatus
  }, {
    validateIcon: displayYPTA && _constant2.FORM_ICONS.WARNING,
    showIcon: !displayYPTA,
    disclaimerModal: isMobile
  }));
};
exports.renderDate = renderDate;
var GuestPersonalInfo = function GuestPersonalInfo(_ref5) {
  var accessible = _ref5.accessible,
    theme = _ref5.theme,
    customProperties = _ref5.customProperties,
    initialValues = _ref5.initialValues,
    nationalities = _ref5.nationalities,
    formRef = _ref5.formRef,
    paxType = _ref5.paxType,
    flightDate = _ref5.flightDate,
    translation = _ref5.translation,
    onSubmit = _ref5.onSubmit,
    handleField = _ref5.handleField,
    hasPopover = _ref5.hasPopover,
    paxAgeRange = _ref5.paxAgeRange,
    gtmParameters = _ref5.gtmParameters,
    gtmLabel = _ref5.gtmLabel,
    fireGtm = _ref5.fireGtm,
    fireGtmClient = _ref5.fireGtmClient,
    gender = _ref5.gender,
    isWMP = _ref5.isWMP,
    autoSelectNationalityOneResult = _ref5.autoSelectNationalityOneResult,
    showNationality = _ref5.showNationality,
    showGivenName = _ref5.showGivenName,
    showFamilyName = _ref5.showFamilyName,
    showGenderField = _ref5.showGenderField,
    showDOBField = _ref5.showDOBField,
    yptaDisclaimerContent = _ref5.yptaDisclaimerContent,
    yptaAgeRange = _ref5.yptaAgeRange,
    showSeniorCitizen = _ref5.showSeniorCitizen,
    seniorCitizenMinimumAge = _ref5.seniorCitizenMinimumAge,
    hasInfant = _ref5.hasInfant,
    maxCharLengthAllowed = _ref5.maxCharLengthAllowed,
    singleClickGender = _ref5.singleClickGender,
    color = _ref5.color,
    selectButtonBackgroundColor = _ref5.selectButtonBackgroundColor,
    selectedButtonBorderColor = _ref5.selectedButtonBorderColor,
    customButtonWidth = _ref5.customButtonWidth,
    allowedNameLength = _ref5.allowedNameLength,
    seniorCitizenIdMaxChar = _ref5.seniorCitizenIdMaxChar,
    checkSeniorCitizenField = _ref5.checkSeniorCitizenField,
    newYpta = _ref5.newYpta,
    exactYptaAgeValidation = _ref5.exactYptaAgeValidation,
    initialValuesCallback = _ref5.initialValuesCallback,
    sortNationlityByCultureCode = _ref5.sortNationlityByCultureCode;
  var _React$useState = _react.default.useState(initialValues),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 1),
    value = _React$useState2[0];
  var innerWidth = function innerWidth() {
    return typeof window !== 'undefined' ? window.innerWidth : 300;
  };
  var _React$useState3 = _react.default.useState(innerWidth()),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    windowWidth = _React$useState4[0],
    setWindowWidth = _React$useState4[1];
  var _React$useState5 = _react.default.useState([]),
    _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
    errorList = _React$useState6[0],
    setErrorList = _React$useState6[1];
  var tabIndex = !accessible ? '-1' : '0';
  var gtmParams = gtmParameters && JSON.parse(gtmParameters);
  var _ref6 = gtmParams || {},
    eventLabelView = _ref6.eventLabelView,
    appName = _ref6.appName,
    lineOfBusiness = _ref6.lineOfBusiness;
  var gtmContext = (0, _GtmContext.useGtmContext)();
  /* istanbul ignore next */
  _react.default.useEffect(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', function () {
        return setWindowWidth(innerWidth());
      });
    }
    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', function () {
          return setWindowWidth(innerWidth());
        });
      }
    };
  }, []);
  _react.default.useEffect(function () {
    if (errorList.length > 0) {
      createErrorGtmObject(errorList, gtmLabel, fireGtm, appName, lineOfBusiness);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorList]);
  var errorCallback = function errorCallback(field, errorObj, add) {
    if (errorObj && fireGtmClient) {
      var getGtmObj = _utilities.default.createGTMObject({
        translationKey: errorObj === null || errorObj === void 0 ? void 0 : errorObj.errorCode,
        displayMessage: errorObj === null || errorObj === void 0 ? void 0 : errorObj.errorMessage
      }, gtmContext);
      fireGtmClient(getGtmObj);
    }
    if (add) {
      var newList = errorList.filter(function (val) {
        return val === field;
      });
      if (newList.length <= 0) {
        setErrorList([].concat((0, _toConsumableArray2.default)(errorList), [field]));
      }
    } else {
      var _newList = errorList.filter(function (val) {
        return val !== field;
      });
      setErrorList((0, _toConsumableArray2.default)(_newList));
    }
  };
  _react.default.useEffect(function () {
    if (formRef) {
      formRef.current.setValues(initialValues);
      // added setTimeout to properly call the validateform when values are already set
      setTimeout(function () {
        formRef.current.validateForm(initialValues).then(function () {
          if (initialValuesCallback) initialValuesCallback();
        });
      }, 0);
    }
    // eslint-disable-next-line  react-hooks/exhaustive-deps
  }, [initialValues]);
  var isMobile = windowWidth <= parseInt(_constant.BREAKPOINTS.MOBILE.replace('px', ''), 10);
  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATION), translation);
  var yptaDisclaimer = {
    title: language.yptaDisclaimerTitle,
    text: yptaDisclaimerContent
  };
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledContainer, (0, _extends2.default)({}, customProperties, {
    tabIndex: !accessible ? '-1' : '0'
  }), /*#__PURE__*/_react.default.createElement(_formik.Formik, (0, _extends2.default)({
    innerRef: formRef,
    initialValues: value
  }, onSubmit && {
    onSubmit: onSubmit
  }, {
    validateOnChange: true,
    enableReinitialize: true
  }), function (props) {
    var renderGiverName = function renderGiverName(fieldProps) {
      return /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: renderField,
        formRef: formRef,
        accessible: accessible,
        alwaysShowLabel: false,
        label: language.givenName || _constant2.FIELDS.givenName.label,
        name: _constant2.FIELDS.givenName.name,
        theme: theme,
        handleField: handleField,
        value: fieldProps.values[_constant2.FIELDS.givenName.name],
        validate: function validate(val) {
          var _removeExtraWhiteSpac;
          return validators(removeExtraWhiteSpaces(val), language.givenName || _constant2.FIELDS.givenName.label, language, allowedNameLength || maxCharLengthAllowed ? [_validate.required, _validate.maxLen, _validate.alphabet] : [_validate.required, _validate.alphabet], allowedNameLength || maxCharLengthAllowed, (_removeExtraWhiteSpac = removeExtraWhiteSpaces(fieldProps.values[_constant2.FIELDS.familyName.name])) === null || _removeExtraWhiteSpac === void 0 ? void 0 : _removeExtraWhiteSpac.length, _constant2.FIELDS.givenName.name);
        },
        isRequired: true,
        gtmParameters: eventLabelView,
        gtmAction: fireGtm,
        createGtmObject: createGtmObject,
        gtmParams: gtmParams,
        gtmLabel: gtmLabel,
        errorCallback: errorCallback,
        touched: fieldProps.touched[_constant2.FIELDS.givenName.name],
        triggerOnChange: true
        // fireGtm={createGtmObject(
        //   fieldProps.values && fieldProps.values[FIELDS.givenName.name]
        //     ? fieldProps.values[FIELDS.givenName.name]
        //     : ''
        // )}
      });
    };

    var renderFamilyName = function renderFamilyName(fieldProps) {
      return /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: renderField,
        accessible: accessible,
        alwaysShowLabel: false,
        label: language.familyName || _constant2.FIELDS.familyName.label,
        name: _constant2.FIELDS.familyName.name,
        theme: theme,
        handleField: handleField,
        value: fieldProps.values[_constant2.FIELDS.familyName.name],
        validate: function validate(val) {
          var _removeExtraWhiteSpac2;
          return validators(removeExtraWhiteSpaces(val), language.familyName || _constant2.FIELDS.familyName.label, language, allowedNameLength || maxCharLengthAllowed ? [_validate.required, _validate.maxLen, _validate.alphabet] : [_validate.required, _validate.alphabet], allowedNameLength || maxCharLengthAllowed, (_removeExtraWhiteSpac2 = removeExtraWhiteSpaces(fieldProps.values[_constant2.FIELDS.givenName.name])) === null || _removeExtraWhiteSpac2 === void 0 ? void 0 : _removeExtraWhiteSpac2.length, _constant2.FIELDS.familyName.name);
        },
        isRequired: true,
        gtmParameters: eventLabelView,
        gtmAction: fireGtm,
        createGtmObject: createGtmObject,
        gtmParams: gtmParams,
        gtmLabel: gtmLabel,
        errorCallback: errorCallback,
        touched: fieldProps.touched[_constant2.FIELDS.familyName.name],
        triggerOnChange: true
      });
    };
    var displayYPTA = toDisplayYPTA(yptaDisclaimerContent, props.values[_constant2.FIELDS.dateOfBirth.name], isMobile, paxType, flightDate, yptaAgeRange, exactYptaAgeValidation);
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      _react.default.createElement("form", {
        onSubmit: props.handleSubmit,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter') {
            props.handleSubmit();
          }
        }
      }, !singleClickGender && /*#__PURE__*/_react.default.createElement(FieldWrapper, {
        isMobile: isMobile,
        title: true
      }, /*#__PURE__*/_react.default.createElement(_Text.default, {
        accessible: false,
        bold: true,
        display: "block",
        theme: theme,
        type: "sub"
      }, language.personalDetails)), /*#__PURE__*/_react.default.createElement(Container, null, showGenderField && singleClickGender && /*#__PURE__*/_react.default.createElement(FieldWrapper, {
        width: 100
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: renderSingleSelect,
        accessible: accessible,
        alwaysShowLabel: false,
        label: language.gender || _constant2.FIELDS.gender.label,
        name: _constant2.FIELDS.gender.name,
        theme: theme,
        items: gender || _constant2.GENDER_OPTIONS,
        handleField: handleField,
        value: props.values[_constant2.FIELDS.gender.name],
        validate: function validate(val) {
          return _validate.required(val, language.gender || _constant2.FIELDS.gender.label, language);
        },
        isMobile: isMobile,
        gtmAction: fireGtm,
        createGtmObject: createGtmObject,
        gtmParams: gtmParams,
        gtmLabel: gtmLabel,
        errorCallback: errorCallback,
        withLabelOpacity: true,
        touched: props.touched[_constant2.FIELDS.gender.name],
        color: color,
        selectButtonBackgroundColor: selectButtonBackgroundColor,
        selectedButtonBorderColor: selectedButtonBorderColor,
        customButtonWidth: customButtonWidth
      })), hasPopover && !isMobile ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showGivenName && /*#__PURE__*/_react.default.createElement(FieldWrapper, {
        width: 50,
        isMobile: isMobile
      }, /*#__PURE__*/_react.default.createElement(_Popover.default, {
        accessible: true,
        header: language.popoverTitle,
        content: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
          accessible: true,
          display: "inlineFlex",
          theme: theme,
          type: "small",
          marginBottom: "tiny"
        }, language.popoverMessage), /*#__PURE__*/_react.default.createElement(_IDCard.default, {
          accessible: true,
          theme: theme
        })),
        customProperties: {
          id: "".concat(customProperties.id, "-popoverGivenName")
        },
        position: "right",
        theme: theme,
        trigger: "focus",
        width: 315
      }, renderGiverName(props))), showFamilyName && /*#__PURE__*/_react.default.createElement(FieldWrapper, {
        width: 50,
        isMobile: isMobile
      }, /*#__PURE__*/_react.default.createElement(_Popover.default, {
        accessible: true,
        header: language.popoverTitle,
        content: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
          accessible: true,
          display: "inlineFlex",
          theme: theme,
          type: "small",
          marginBottom: "tiny"
        }, language.popoverMessage), /*#__PURE__*/_react.default.createElement(_IDCard.default, {
          accessible: true,
          theme: theme
        })),
        customProperties: {
          id: "".concat(customProperties.id, "-popoverFamilyName")
        },
        position: "right",
        theme: theme,
        trigger: "focus",
        width: 315,
        zIndex: 11
      }, renderFamilyName(props)))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showGivenName && /*#__PURE__*/_react.default.createElement(FieldWrapper, {
        width: 50,
        isMobile: isMobile
      }, renderGiverName(props)), showFamilyName && /*#__PURE__*/_react.default.createElement(FieldWrapper, {
        width: 50,
        isMobile: isMobile
      }, renderFamilyName(props))), showNationality && /*#__PURE__*/_react.default.createElement(FieldWrapper, {
        width: 50,
        isMobile: isMobile
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: renderDropdown,
        theme: theme,
        accessible: accessible,
        alwaysShowLabel: false,
        label: language.nationality || _constant2.FIELDS.nationality.label,
        name: _constant2.FIELDS.nationality.name,
        items: nationalities.map(function (nationality) {
          return {
            iconName: '',
            value: nationality.countryCode || nationality.value,
            iconDisplayName: '',
            mainDisplayName: nationality.name,
            subDisplayName: '',
            label: nationality.name
          };
        }),
        handleField: handleField,
        value: props.values[_constant2.FIELDS.nationality.name],
        validate: function validate(val) {
          return _validate.required(val, language.nationality || _constant2.FIELDS.nationality.name, language);
        },
        isMobile: isMobile,
        width: isMobile ? '' : '368px',
        placeHolder: _constant2.TRANSLATION.searchNationality,
        isNewVersion: true,
        onSelect: function onSelect(obj) {
          return obj;
        },
        locale: _constant2.TRANSLATION,
        supportOneCharacterSearch: true,
        viewPort: isMobile ? 'mobile' : 'desktop',
        customDisplayField: "mainDisplayName",
        withBoxShadow: false,
        gtmAction: fireGtm,
        createGtmObject: createGtmObject,
        gtmParams: gtmParams,
        gtmLabel: gtmLabel,
        errorCallback: errorCallback,
        autoSelectOneResult: autoSelectNationalityOneResult,
        touched: props.touched[_constant2.FIELDS.nationality.name],
        formRef: formRef,
        sortNationlityByCultureCode: sortNationlityByCultureCode
      })), showDOBField && singleClickGender && /*#__PURE__*/_react.default.createElement(FieldWrapper, {
        width: 50
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: renderDate,
        accessible: accessible,
        alwaysShowLabel: false,
        label: language.dateOfBirth || _constant2.FIELDS.dateOfBirth.label,
        name: _constant2.FIELDS.dateOfBirth.name,
        theme: theme,
        handleField: handleField,
        value: props.values[_constant2.FIELDS.dateOfBirth.name],
        validate: function validate(val) {
          return _validate.date(val, language.dateOfBirth || _constant2.FIELDS.dateOfBirth.label, language, isMobile, paxType, flightDate, true, paxAgeRange, false, true, hasInfant, yptaDisclaimerContent, yptaAgeRange, newYpta, exactYptaAgeValidation);
        },
        isMobile: isMobile && !isWMP,
        gtmAction: fireGtm,
        createGtmObject: createGtmObject,
        gtmParams: gtmParams,
        gtmLabel: gtmLabel,
        errorCallback: errorCallback,
        placeholder: language.dateFormat,
        isRequired: true,
        touched: props.touched[_constant2.FIELDS.dateOfBirth.name],
        triggerOnChange: true,
        displayYPTA: displayYPTA && newYpta,
        disclaimer: yptaDisclaimer
      })), /*#__PURE__*/_react.default.createElement(FieldGroup, {
        isMobile: isMobile
      }, showGenderField && !singleClickGender && /*#__PURE__*/_react.default.createElement(FieldWrapper, {
        width: 50
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: renderSelect,
        accessible: accessible,
        alwaysShowLabel: false,
        label: language.gender || _constant2.FIELDS.gender.label,
        name: _constant2.FIELDS.gender.name,
        theme: theme,
        items: gender || _constant2.GENDER_OPTIONS,
        handleField: handleField,
        value: props.values[_constant2.FIELDS.gender.name],
        validate: function validate(val) {
          return _validate.required(val, language.gender || _constant2.FIELDS.gender.label, language);
        },
        isMobile: isMobile,
        gtmAction: fireGtm,
        createGtmObject: createGtmObject,
        gtmParams: gtmParams,
        gtmLabel: gtmLabel,
        errorCallback: errorCallback,
        withLabelOpacity: true,
        touched: props.touched[_constant2.FIELDS.gender.name]
      })), showDOBField && !singleClickGender && /*#__PURE__*/_react.default.createElement(FieldWrapper, {
        width: 50
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: renderDate,
        accessible: accessible,
        alwaysShowLabel: false,
        label: language.dateOfBirth || _constant2.FIELDS.dateOfBirth.label,
        name: _constant2.FIELDS.dateOfBirth.name,
        theme: theme,
        handleField: handleField,
        value: props.values[_constant2.FIELDS.dateOfBirth.name],
        validate: function validate(val) {
          return _validate.date(val, language.dateOfBirth || _constant2.FIELDS.dateOfBirth.label, language, isMobile, paxType, flightDate, true, paxAgeRange, false, true, hasInfant, yptaDisclaimerContent, yptaAgeRange, newYpta, exactYptaAgeValidation);
        },
        isMobile: isMobile && !isWMP,
        gtmAction: fireGtm,
        createGtmObject: createGtmObject,
        gtmParams: gtmParams,
        gtmLabel: gtmLabel,
        errorCallback: errorCallback,
        placeholder: language.dateFormat,
        isRequired: true,
        touched: props.touched[_constant2.FIELDS.dateOfBirth.name],
        triggerOnChange: true,
        displayYPTA: displayYPTA && newYpta,
        disclaimer: yptaDisclaimer
      }))), showSeniorCitizen && showSeniorCitizenField(props.values[_constant2.FIELDS.dateOfBirth.name], isMobile, paxType, flightDate, seniorCitizenMinimumAge, checkSeniorCitizenField) && /*#__PURE__*/_react.default.createElement(FieldWrapper, {
        width: isMobile ? 100 : 50
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: renderField,
        accessible: accessible,
        alwaysShowLabel: false,
        label: language.seniorCitizenId || _constant2.FIELDS.seniorCitizenId.label,
        name: _constant2.FIELDS.seniorCitizenId.name,
        theme: theme,
        handleField: handleField,
        gtmAction: fireGtm,
        createGtmObject: createGtmObject,
        gtmParams: gtmParams,
        gtmLabel: gtmLabel,
        errorCallback: errorCallback,
        value: props.values[_constant2.FIELDS.seniorCitizenId.name],
        validate: function validate(val) {
          return validators(removeExtraWhiteSpaces(val), language.seniorCitizenId || _constant2.FIELDS.seniorCitizenId.label, language, maxCharLengthAllowed || seniorCitizenIdMaxChar ? [_validate.required, _validate.maxLen, _validate.alphanumeric] : [_validate.required, _validate.alphanumeric], maxCharLengthAllowed || seniorCitizenIdMaxChar, _constant2.FIELDS.seniorCitizenId.name);
        },
        isRequired: true,
        touched: props.touched[_constant2.FIELDS.seniorCitizenId.name]
      }))), displayYPTA && !newYpta && /*#__PURE__*/_react.default.createElement(StyledYptaDisclaimerContainer, null, /*#__PURE__*/_react.default.createElement(_CardInfo.default, (0, _extends2.default)({}, props, {
        accessible: accessible,
        content: yptaDisclaimerContent,
        customProperties: {
          id: 'ypta-disclaimer'
        },
        hasBoxShadow: false,
        icon: _constant2.FORM_ICONS.OLD_YPTA_DISCLAIMER,
        iconSize: "title",
        theme: theme,
        title: language.yptaDisclaimerTitle,
        titleFirst: true,
        translation: language,
        hasTextToggle: isMobile
      }, isMobile && {
        textLimit: _constant2.YPTA_DISCLAIMER_TEXT_LIMIT
      }))))
    );
  })));
};
GuestPersonalInfo.propTypes = _GuestPersonalInfo.default.PropTypes;
GuestPersonalInfo.defaultProps = _GuestPersonalInfo.default.DefaultProps;
var _default = GuestPersonalInfo;
exports.default = _default;